<template>
    <div id="swagger-ui"></div>
</template>

<script>
import { hide_navbar, show_navbar } from '../utils/nav_utils';
import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle.js'
import 'swagger-ui-dist/swagger-ui.css';
import { refreshTokenIfExpired } from "../utils/cognito";

export default {
    name: 'Docs',
    async mounted() {
        hide_navbar(); // Hide the entire navbar

        await refreshTokenIfExpired();

        const openapiUrl = process.env.VUE_APP_API_URL + '/openapi.json'
        const auth = localStorage.getItem('auth')

        fetch(openapiUrl, {
            headers: {
                Authorization: auth,
            },
        })
        .then(response => {
            if (!response.ok) {
                console.error('Failed to load OpenAPI spec:', response.statusText)
                return null
            }
            return response.json()
        })
        .then(openapiSpec => {
            if (!openapiSpec) return
            // Add servers field if missing
            if (!openapiSpec.servers) {
                openapiSpec.servers = [{ url: process.env.VUE_APP_API_URL }]
            }
            SwaggerUIBundle({
                spec: openapiSpec,
                dom_id: '#swagger-ui',
                layout: 'BaseLayout',
                deepLinking: true,
                showExtensions: true,
                showCommonExtensions: true,
                persistAuthorization: true,
                requestInterceptor: (req) => {
                    req.headers['Authorization'] = auth
                    return req
                },
                presets: [
                    SwaggerUIBundle.presets.apis,
                    SwaggerUIBundle.SwaggerUIStandalonePreset,
                ],
            })
        })
        .catch(err => {
            console.error('Error loading OpenAPI spec:', err)
        })
    },
    beforeDestroy() {
        show_navbar(); // Show the navbar again when leaving
    }
}
</script>

<style>
#swagger-ui {
  text-align: left !important;
  display: block !important;
}
</style>
